module.exports = __webpack_public_path__ + "img/cfcta-redo.0b0e4e11.png";